export function setOwnedReferralCodes(code: string): void {
  let ownedCodes: string[];

  const stored = localStorage.getItem('referral_codes');
  if (stored === null) {
    ownedCodes = [];
  } else {
    try {
      ownedCodes = JSON.parse(stored);
    } catch {
      ownedCodes = [];
    }
  }

  if (!ownedCodes.includes(code) && code !== null && code !== undefined) {
    ownedCodes.push(code);
    localStorage.setItem('referral_codes', JSON.stringify(ownedCodes));
  }
}

export function getReferralCode(): string | null {
  const referralCode = localStorage.getItem('user_referral_code');

  return referralCode;
}

export function validateReferralCode(): string {
  let ownedCodes: string[];
  const referralCode = localStorage.getItem('user_referral_code');
  let referredBySameBrowser = '0';

  const stored = localStorage.getItem('referral_codes');
  if (stored === null) {
    ownedCodes = [];
  } else {
    try {
      ownedCodes = JSON.parse(stored);
    } catch {
      ownedCodes = [];
    }
  }

  if (ownedCodes.includes(referralCode as string)) {
    referredBySameBrowser = '1';
  }

  return referredBySameBrowser;
}

// Track length in minute:second.
export function convertToMinutesAndSeconds(time: number): string {
  // Better handling of sound effects that are less than 0.5 seconds
  if (time <= 0.1 && time !== 0) {
    time = 1;
  }

  const minutes = Math.floor(time / 60);
  const seconds = time % 60;

  return `${minutes}:${String(seconds).padStart(2, '0')}`;
}

interface WeightedItem {
  weighting: number;
  [key: string]: unknown;
}

export const getEnergy = (energyId: number, trackId: number): string => {
  // Array of 10 gradient image URLs to cycle through
  const gradientCount = 10;
  const gradientIndex = (trackId % gradientCount) + 1; // 1-indexed for URLs

  return `https://cdn.uppbeat.io/based-on-your-downloads/${gradientIndex}.jpg`;
};
